import { HttpResponse } from 'interfaces/http-response.interface';

export const isResponseOk = (response: HttpResponse<any, any> | undefined) => {
    return response?.status === 200 || response?.status === 201;
};
